import { VaroCategories } from 'shared/analytics/types/categories';
import { createBaseEventsMap } from 'shared/analytics/utils/createBaseEventsMap';

const EVENT_KEYS = {
  TRANSFER_MONEY_REQUEST_COMPLETED: 'Transfer Money Request Completed',
  TRANSFER_MONEY_SELECT_ACCOUNT_CLICKED:
    'Transfer Money Select Account Clicked',
  TRANSFER_MONEY_ACCOUNT_SELECTED: 'Transfer Money Account Selected',
  TRANSFER_MONEY_FORM_COMPLETED: 'Transfer Money Form Completed',
  TRANSFER_INLINE_ERROR_ENCOUNTERED: 'Transfer Inline Error Encountered',
  TRANSFER_MONEY_REQUEST_SUBMITTED: 'Transfer Money Request Submitted',
  TRANSFER_MONEY_SUCCESSFUL: 'Transfer Money Successful',
  TRANSFER_MONEY_FLOW_ERROR_ENCOUNTERED:
    'Transfer Money Flow Error Encountered',
};

/** The data team's transfer_type values, shared by every transfer entry point. */
export const TRANSFER_TYPES = {
  INTERNAL: 'internal',
  ACH_PUSH: 'ach_push',
  ACH_PULL: 'ach_pull',
  PUSH_TO_CARD: 'external_debit_push',
} as const;

export type VaroTransferMoneyEvents =
  (typeof EVENT_KEYS)[keyof typeof EVENT_KEYS];

const events = createBaseEventsMap<VaroTransferMoneyEvents>(
  EVENT_KEYS,
  VaroCategories.TRANSFER_MONEY,
);

export const {
  TRANSFER_MONEY_REQUEST_COMPLETED,
  TRANSFER_MONEY_SELECT_ACCOUNT_CLICKED,
  TRANSFER_MONEY_ACCOUNT_SELECTED,
  TRANSFER_MONEY_FORM_COMPLETED,
  TRANSFER_INLINE_ERROR_ENCOUNTERED,
  TRANSFER_MONEY_REQUEST_SUBMITTED,
  TRANSFER_MONEY_SUCCESSFUL,
  TRANSFER_MONEY_FLOW_ERROR_ENCOUNTERED,
} = events;
